export const EDIT_DOMAINS = {
  demographics: ["admin", "clinician", "front_desk"],
  clinical: ["admin", "clinician"],
  billing: ["admin", "billing"],
  documents: ["admin", "clinician", "front_desk"],
};

export const canEdit = (user, domain) => !!user && (EDIT_DOMAINS[domain] || []).includes(user.role);
